import styles from 'styles/layout/footer.module.css';

export default function Footer({ children }) {
  return <footer>{children}</footer>;
}
